// import React, { useEffect, useRef, useState } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { BrandCraftVideo } from "..";
// import "../videoPoster/videoImg.scss";

// gsap.registerPlugin(ScrollTrigger);

// const VideoImg = () => {
//   const containerRef = useRef(null);
//   const videoRef = useRef(null);
//   const [hasInteracted, setHasInteracted] = useState(false);

//   useEffect(() => {
//     const videoEl = videoRef.current;
//     const containerEl = containerRef.current;

//     const handleUserInteraction = () => {
//       setHasInteracted(true);
//       if (videoEl) {
//         videoEl.muted = false;
//         videoEl.play().catch((err) =>
//           console.warn("Play failed after interaction:", err)
//         );
//       }
//       window.removeEventListener("click", handleUserInteraction);
//     };

//     // Attach listener only if user hasn't interacted yet
//     if (!hasInteracted) {
//       window.addEventListener("click", handleUserInteraction);
//     }

//     if (videoEl && containerEl) {
//       gsap.fromTo(
//         videoEl,
//         { scale: 0.8, opacity: 0 },
//         {
//           scale: 1,
//           opacity: 1,
//           duration: 1,
//           ease: "power3.out",
//           scrollTrigger: {
//             trigger: containerEl,
//             start: "top 80%",
//             end: "bottom 20%",
//             toggleActions: "play none none reverse",
//             onEnter: () => {
//               if (hasInteracted) {
//                 videoEl.play().catch((err) =>
//                   console.warn("Play failed:", err)
//                 );
//               }
//             },
//             onLeaveBack: () => videoEl.pause(),
//             scrub: true,
//           },
//         }
//       );
//     }

//     return () => {
//       window.removeEventListener("click", handleUserInteraction);
//       ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
//     };
//   }, [hasInteracted]);

//   return (
//     <div id="about" className="container" style={{ height: "100%", padding: "30px 0 0" }}>
//       <div
//         className="video"
//         ref={containerRef}
//         style={{ width: "100%", height: "100%" }}
//       >
//         <video
//           ref={videoRef}
//           muted={false} // initially muted
//           controls={true}
//           autoPlay={false} // start without autoplay
//           loop={true}
//           playsInline={true}
//           style={{ width: "100%", opacity: 0, objectFit: "cover" }}
//         >
//           <source src={BrandCraftVideo} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       </div>
//     </div>
//   );
// };

// export default VideoImg;

import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BrandCraftVideo } from "..";
import "../videoPoster/videoImg.scss";

gsap.registerPlugin(ScrollTrigger);

const VideoImg = () => {
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  // const [hasInteracted, setHasInteracted] = useState(false);

  // 👇 Handle user interaction once
  // useEffect(() => {
    // const videoEl = videoRef.current;

  //   const handleUserInteraction = () => {
  //     setHasInteracted(true);
  //     window.removeEventListener("click", handleUserInteraction);
  //   };

  //   window.addEventListener("click", handleUserInteraction);
  //   return () => window.removeEventListener("click", handleUserInteraction);
  // }, []);

  useEffect(() => {
    const videoEl = videoRef.current;
    const containerEl = containerRef.current;

    if (videoEl && containerEl) {
      // Animate in + control playback with scroll
      gsap.fromTo(
        videoEl,
        { scale: 0.8, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: containerEl,
            start: "top 80%",   // when section enters
            end: "bottom 20%",  // when section leaves
            toggleActions: "play none none reverse",
            onEnter: () => videoEl.play(),
            onEnterBack: () => videoEl.play(),
            onLeave: () => videoEl.pause(),
            onLeaveBack: () => videoEl.pause(),
          },
        }
      );
    }

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div
      id="about"
      className="container"
      style={{ height: "100%", padding: "30px 0 0" }}
    >
      <div
        className="video"
        ref={containerRef}
        style={{ width: "100%", height: "100%" }}
      >
        <video
          ref={videoRef}
          muted
          controls
          autoPlay
          loop
          playsInline
          preload="auro"
          // poster="/images/video-placeholder.jpg" 
          style={{ width: "100%", opacity: 0, objectFit: "cover" }}
        >
          <source src={BrandCraftVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoImg;

